import { useContext } from "react";
import { ThemeContext } from "../contexts/Extras/ThemeContext";

const useTheme = () => useContext(ThemeContext);

export default useTheme;
